import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { DataCardService } from '../data-card.service';

@Component({
  selector: 'data-card-dates',
  templateUrl: './data-card-dates.component.html',
  styleUrls: ['./data-card-dates.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class DataCardDatesComponent {

  @Input() dates;
  changedRowIndex:number;

  constructor(private _dataCardService: DataCardService) {}

  ngOnInit() {
    this._dataCardService.onIndexChange.subscribe( (v) => {
      this.changedRowIndex = v;
    });
  }

  onRowSelected(index) {
    this._dataCardService.notifyAll(index);
  }
}


// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-card-dates/data-card-dates.component.ts